import React from "react";

import TabletVeriticalSvg from "../../assets/images/icons/tablet-vertical.svg";

export const TabletVerticalIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={TabletVeriticalSvg}
        alt={alt || "Tablet Vertical"}
    />
);
